/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ትማሊ",
        "0": "ሎሚ",
        "1": "ጽባሕ",
        "future": {
          "one": "ኣብ {0} መዓልቲ",
          "other": "ኣብ {0} መዓልቲ"
        },
        "past": {
          "one": "ቅድሚ {0} መዓልቲ",
          "other": "ኣብ {0} መዓልቲ"
        }
      },
      "day-narrow": {
        "-1": "ትማሊ",
        "0": "ሎሚ",
        "1": "ጽባሕ",
        "future": {
          "one": "ኣብ {0} መዓልቲ",
          "other": "ኣብ {0} መዓልቲ"
        },
        "past": {
          "one": "ቅድሚ {0} መዓልቲ",
          "other": "ቅድሚ {0} መዓልቲ"
        }
      },
      "day-short": {
        "-1": "ትማሊ",
        "0": "ሎሚ",
        "1": "ጽባሕ",
        "future": {
          "one": "ኣብ {0} መዓልቲ",
          "other": "ኣብ {0} መዓልቲ"
        },
        "past": {
          "one": "ቅድሚ {0} መዓልቲ",
          "other": "ቅድሚ {0} መዓልቲ"
        }
      },
      "hour": {
        "0": "ኣብዚ ሰዓት",
        "future": {
          "one": "ኣብ {0} ሰዓት",
          "other": "ኣብ {0} ሰዓት"
        },
        "past": {
          "one": "ቅድሚ {0} ሰዓት",
          "other": "ቅድሚ {0} ሰዓት"
        }
      },
      "hour-narrow": {
        "0": "ኣብዚ ሰዓት",
        "future": {
          "one": "ኣብ {0} ሰዓት",
          "other": "ኣብ {0} ሰዓት"
        },
        "past": {
          "one": "ቅድሚ {0} ሰዓት",
          "other": "ቅድሚ {0} ሰዓት"
        }
      },
      "hour-short": {
        "0": "ኣብዚ ሰዓት",
        "future": {
          "one": "ኣብ {0} ሰዓት",
          "other": "ኣብ {0} ሰዓት"
        },
        "past": {
          "one": "ቅድሚ {0} ሰዓት",
          "other": "ቅድሚ {0} ሰዓት"
        }
      },
      "minute": {
        "0": "ኣብዚ ደቒቕ",
        "future": {
          "one": "ኣብ {0} ደቒቕ",
          "other": "ኣብ {0} ደቒቕ"
        },
        "past": {
          "one": "ቅድሚ {0} ደቒቕ",
          "other": "ቅድሚ {0} ደቒቕ"
        }
      },
      "minute-narrow": {
        "0": "ኣብዚ ደቒቕ",
        "future": {
          "one": "ኣብ {0} ደቒቕ",
          "other": "ኣብ {0} ደቒቕ"
        },
        "past": {
          "one": "ቅድሚ {0} ደቒቕ",
          "other": "ቅድሚ {0} ደቒቕ"
        }
      },
      "minute-short": {
        "0": "ኣብዚ ደቒቕ",
        "future": {
          "one": "ኣብ {0} ደቒቕ",
          "other": "ኣብ {0} ደቒቕ"
        },
        "past": {
          "one": "ቅድሚ {0} ደቒቕ",
          "other": "ቅድሚ {0} ደቒቕ"
        }
      },
      "month": {
        "-1": "ዝሓለፈ ወርሒ",
        "0": "ህሉው ወርሒ",
        "1": "ዝመጽእ ወርሒ",
        "future": {
          "one": "ኣብ {0} ወርሒ",
          "other": "ኣብ {0} ወርሒ"
        },
        "past": {
          "one": "ቅድሚ {0} ወርሒ",
          "other": "ቅድሚ {0} ወርሒ"
        }
      },
      "month-narrow": {
        "-1": "ዝሓለፈ ወርሒ",
        "0": "ህሉው ወርሒ",
        "1": "ዝመጽእ ወርሒ",
        "future": {
          "one": "ኣብ {0} ወርሒ",
          "other": "ኣብ {0} ወርሒ"
        },
        "past": {
          "one": "ቅድሚ {0} ወርሒ",
          "other": "ቅድሚ {0} ወርሒ"
        }
      },
      "month-short": {
        "-1": "ዝሓለፈ ወርሒ",
        "0": "ህሉው ወርሒ",
        "1": "ዝመጽእ ወርሒ",
        "future": {
          "one": "ኣብ {0} ወርሒ",
          "other": "ኣብ {0} ወርሒ"
        },
        "past": {
          "one": "ቅድሚ {0} ወርሒ",
          "other": "ቅድሚ {0} ወርሒ"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "ዝሓለፈ ርብዒ",
        "0": "ህሉው ርብዒ",
        "1": "ዝመጽእ ርብዒ",
        "future": {
          "one": "ኣብ {0} ርብዒ",
          "other": "ኣብ {0} ርብዒ"
        },
        "past": {
          "one": "ቅድሚ {0} ርብዒ",
          "other": "ቅድሚ {0} ርብዒ"
        }
      },
      "quarter-narrow": {
        "-1": "ዝሓለፈ ርብዒ",
        "0": "ህሉው ርብዒ",
        "1": "ዝመጽእ ርብዒ",
        "future": {
          "one": "ኣብ {0} ርብዒ",
          "other": "ኣብ {0} ርብዒ"
        },
        "past": {
          "one": "ቅድሚ {0} ርብዒ",
          "other": "ቅድሚ {0} ርብዒ"
        }
      },
      "quarter-short": {
        "-1": "ዝሓለፈ ርብዒ",
        "0": "ህሉው ርብዒ",
        "1": "ዝመጽእ ርብዒ",
        "future": {
          "one": "ኣብ {0} ርብዒ",
          "other": "ኣብ {0} ርብዒ"
        },
        "past": {
          "one": "ቅድሚ {0} ርብዒ",
          "other": "ቅድሚ {0} ርብዒ"
        }
      },
      "second": {
        "0": "ሕጂ",
        "future": {
          "one": "ኣብ {0} ካልኢት",
          "other": "ኣብ {0} ካልኢት"
        },
        "past": {
          "one": "ቅድሚ {0} ካልኢት",
          "other": "ቅድሚ {0} ካልኢት"
        }
      },
      "second-narrow": {
        "0": "ሕጂ",
        "future": {
          "one": "ኣብ {0} ካልኢት",
          "other": "ኣብ {0} ካልኢት"
        },
        "past": {
          "one": "ቅድሚ {0} ካልኢት",
          "other": "ቅድሚ {0} ካልኢት"
        }
      },
      "second-short": {
        "0": "ሕጂ",
        "future": {
          "one": "ኣብ {0} ካልኢት",
          "other": "ኣብ {0} ካልኢት"
        },
        "past": {
          "one": "ቅድሚ {0} ካልኢት",
          "other": "ቅድሚ {0} ካልኢት"
        }
      },
      "week": {
        "-1": "ዝሓለፈ ሰሙን",
        "0": "ህሉው ሰሙን",
        "1": "ዝመጽእ ሰሙን",
        "future": {
          "one": "ኣብ {0} ሰሙን",
          "other": "ኣብ {0} ሰሙን"
        },
        "past": {
          "one": "ቅድሚ {0} ሰሙን",
          "other": "ቅድሚ {0} ሰሙን"
        }
      },
      "week-narrow": {
        "-1": "ዝሓለፈ ሰሙን",
        "0": "ህሉው ሰሙን",
        "1": "ዝመጽእ ሰሙን",
        "future": {
          "one": "ኣብ {0} ሰሙን",
          "other": "ኣብ {0} ሰሙን"
        },
        "past": {
          "one": "ቅድሚ {0} ሰሙን",
          "other": "ቅድሚ {0} ሰሙን"
        }
      },
      "week-short": {
        "-1": "ዝሓለፈ ሰሙን",
        "0": "ህሉው ሰሙን",
        "1": "ዝመጽእ ሰሙን",
        "future": {
          "one": "ኣብ {0} ሰሙን",
          "other": "ኣብ {0} ሰሙን"
        },
        "past": {
          "one": "ቅድሚ {0} ሰሙን",
          "other": "ቅድሚ {0} ሰሙን"
        }
      },
      "year": {
        "-1": "ዓሚ",
        "0": "ሎሚ ዓመት",
        "1": "ንዓመታ",
        "future": {
          "one": "ኣብ {0} ዓ",
          "other": "ኣብ {0} ዓ"
        },
        "past": {
          "one": "ቅድሚ {0} ዓ",
          "other": "ቅድሚ {0} ዓ"
        }
      },
      "year-narrow": {
        "-1": "ዓሚ",
        "0": "ሎሚ ዓመት",
        "1": "ንዓመታ",
        "future": {
          "one": "ኣብ {0} ዓ",
          "other": "ኣብ {0} ዓ"
        },
        "past": {
          "one": "ቅድሚ {0} ዓ",
          "other": "ቅድሚ {0} ዓ"
        }
      },
      "year-short": {
        "-1": "ዓሚ",
        "0": "ሎሚ ዓመት",
        "1": "ንዓመታ",
        "future": {
          "one": "ኣብ {0} ዓ",
          "other": "ኣብ {0} ዓ"
        },
        "past": {
          "one": "ቅድሚ -{0} ዓ",
          "other": "ቅድሚ {0} ዓ"
        }
      }
    },
    "locale": "ti-ER"
  });
}